/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { MyDonationsResponse } from '../../models/my-donations-response';

export interface TravelControllerGetMyDonations$Params {
}

export function travelControllerGetMyDonations(http: HttpClient, rootUrl: string, params?: TravelControllerGetMyDonations$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MyDonationsResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerGetMyDonations.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: MyDonationsResponse;
      }>;
    })
  );
}

travelControllerGetMyDonations.PATH = '/travel/my-donations';
